<template>
  <p class="value-crud-action">
    <collection-value-show-action  v-if="!exclude.includes('show')" :item="item" :model="model"></collection-value-show-action> 
    <collection-value-edit-action  v-if="!exclude.includes('edit')" :item="item" :model="model"></collection-value-edit-action> 
    <collection-value-delete-action  v-if="!exclude.includes('delete')" :item="item" :model="model"></collection-value-delete-action>
  </p>
</template>
<script>
import CollectionValueShowAction from './CollectionValueShowAction'
import CollectionValueEditAction from './CollectionValueEditAction'
import CollectionValueDeleteAction from './CollectionValueDeleteAction'

export default {
  props: ['item', 'column', 'model'],
  components: {
    CollectionValueShowAction,
    CollectionValueEditAction,
    CollectionValueDeleteAction
  },
  computed: {
    exclude(){
      if(this.column.exclude){
        return this.column.exclude
      }else{
        return []
      }
    }
  }
}
</script>
<style lang="scss">
.value-crud-action > p {
  display: inline-block;
}
</style>




// WEBPACK FOOTER //
// CollectionValueCrudAction.vue?b5cba576